import React, { useEffect, useState } from "react";

const euro = (v) =>
  (Number(v) || 0).toLocaleString("fr-FR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }) + " €";

// Overlay festif affiché après validation d'un devis : compte le montant de commission
// de 0 → valeur finale, puis se retire tout seul.
export default function CommissionCelebration({ amount, onDone }) {
  const [display, setDisplay] = useState(0);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    const start = performance.now();
    const dur = 800;
    let raf;
    const tick = (now) => {
      const p = Math.min(1, (now - start) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(amount * eased);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    const tLeave = setTimeout(() => setLeaving(true), 2600);
    const tDone = setTimeout(() => onDone?.(), 3150);
    return () => {
      cancelAnimationFrame(raf);
      clearTimeout(tLeave);
      clearTimeout(tDone);
    };
  }, [amount, onDone]);

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center pointer-events-none">
      <div
        className={`pointer-events-none rounded-3xl border border-emerald-400/30 shadow-2xl px-10 py-8 text-center bg-gradient-to-br from-emerald-500 to-emerald-600 text-white transition-all duration-500 ${
          leaving ? "opacity-0 scale-95 -translate-y-6" : "opacity-100"
        }`}
        style={leaving ? undefined : { animation: "commPop .55s cubic-bezier(.22,1.2,.36,1)" }}
      >
        <div className="text-3xl mb-1">🎉</div>
        <div className="text-sm font-semibold uppercase tracking-wider text-emerald-50/90">
          Devis validé
        </div>
        <div className="mt-2 text-5xl font-extrabold drop-shadow-sm">
          +{euro(display)}
        </div>
        <div className="mt-1 text-sm text-emerald-50/90">de commission 💰</div>
      </div>

      <style>{`
        @keyframes commPop {
          0%   { transform: scale(.6); opacity: 0; }
          60%  { transform: scale(1.06); opacity: 1; }
          100% { transform: scale(1); opacity: 1; }
        }
      `}</style>
    </div>
  );
}
